import "./PortCodesPage.scss";

import PortCode from "../../components/PortCodes/PortCode/PortCode";

const PortCodesPage = () => {
	return <PortCode />;
};

export default PortCodesPage;
